<template>
    <div>
        <card-header icon="fa-file-certificate" :title="conf.user.first_name + ' ' + conf.user.last_name"/>

        <card-body v-if="conf.id">
            <card-list>
                <subheader-list-item icon="fa-presentation" title="Conference"/>

                <container-list-item>
                    <data-row title="Title">{{ conf.conference.title }}</data-row>
                    <data-row title="Date">{{ confDates }}</data-row>
                    <data-row title="Location">{{ conf.conference.location }}</data-row>
                </container-list-item>

                <subheader-list-item icon="fa-certificate" title="Application"/>

                <container-list-item>
                    <data-row title="Name">{{ conf.user.first_name }} {{ conf.user.last_name }}</data-row>
                    <data-row title="Email">{{ conf.user.email }}</data-row>
                    <data-row title="Phone">{{ conf.user.phone | tel }}</data-row>
                    <data-row title="Date">{{ conf.updated_at | moment('MMMM Do, h:mm A') }}</data-row>
                </container-list-item>

                <separator-list-item/>

                <container-list-item>
                    <data-row title="Total Minutes">{{ conf.registration.total_minutes }}</data-row>
                    <data-row title="Clock Hours">{{ conf.registration.clock_hours }}</data-row>
                </container-list-item>

                <separator-list-item/>

                <container-list-item>
                    <data-row title="Signature">
                        <img :src="getData(conf, 'log').signature" class="mt-3" style="max-width: 100%;"/>
                    </data-row>
                </container-list-item>

                <subheader-list-item icon="fa-clipboard-list-check" title="Record Log"/>

                <card-list-item v-for="log in conf.registration.reg_record_log">
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="tile-title">{{ log.title }}</div>
                        <div class="meta mt-1">{{ displayDates(log.start_at, log.end_at) }} ({{ log.minutes }} min)</div>
                    </template>
                </card-list-item>


                <subheader-list-item icon="fa-messages-question" title="Survey"/>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">This conference met the goals and objectives as described in the sessions catalog.</div>
                        <div class="tile-title mt-1">{{ responses[getData(conf, 'eval').q1] }}</div>
                    </template>
                </card-list-item>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">I was/am able to apply the learning from this conference in my educational setting.</div>
                        <div class="tile-title mt-1">{{ responses[getData(conf, 'eval').q1] }}</div>
                    </template>
                </card-list-item>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">This conference was well organized and meets at least one content criteria.</div>
                        <div class="tile-title mt-1">{{ responses[getData(conf, 'eval').q1] }}</div>
                    </template>
                </card-list-item>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">The technology used in this conference was what was needed.</div>
                        <div class="tile-title mt-1">{{ responses[getData(conf, 'eval').q1] }}</div>
                    </template>
                </card-list-item>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">The presentations/presenters in this conference were well prepared.</div>
                        <div class="tile-title mt-1">{{ responses[getData(conf, 'eval').q1] }}</div>
                    </template>
                </card-list-item>

                <card-list-item>
                    <template v-slot:icon><i class="far fa-fw"></i></template>
                    <template v-slot:content>
                        <div class="meta">Additional Comments</div>
                        <div class="tile-title mt-1">{{ getData(conf, 'eval').comments || 'Not provided.'}}</div>
                    </template>
                </card-list-item>

                <subheader-list-item icon="fa-certificate" title="Certification"/>

                <container-list-item>
                    <data-row title="Certification">Washington State Professional Development (Clock Hours)</data-row>
                    <data-row title="Provider">{{ conf.organization.title }}</data-row>
                    <data-row title="Max Clock Hours">{{ conf.config.units.toFixed(2) }}</data-row>
                </container-list-item>

            </card-list>

        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <b-button type="is-danger" size="is-small" class="m-2" @click="reject()">
                        <b-icon icon="times" class="mr-2"></b-icon>
                        Reject
                    </b-button>
                </div>
                <div class="column">
                    <div class="is-pulled-right">
                        <b-button type="is-success" size="is-small" class="m-2" @click="approve()">
                            <b-icon icon="check" class="mr-2"></b-icon>
                            Approve
                        </b-button>
                    </div>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import DataRow from "../../TIER/components/DataRow";
    import moment from "moment";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import CardListItem from "../../TIER/components/CardListItem";

    export default {
        components: {CardListItem, SeparatorListItem, DataRow, ContainerListItem, SubheaderListItem, CardList, CardFooter, RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function() {
            return {
                conf: {
                    user: {},
                    conference: {},
                    organization: {},
                    config: {units: 0, data: []},
                    registration: {},
                },
                responses: {
                    'NA': 'Not Applicable',
                    'SD': 'Strongly Disagree',
                    'D': 'Disagree',
                    'N': 'Neutral',
                    'A': 'Agree',
                    'SA': 'Strongly Agree'
                }
            };
        },
        computed: {
            confDates: function() {
                let s = moment(this.conf.conference.start_at);
                let e = moment(this.conf.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
        },
        methods: {
            loadReview: function() {
                console.log(this.props.reviewId);
                this.$emit('loading', true);
                // todo too specific
                http.get('/certifications/pending/' + this.props.reviewId, {force: true}).then(response => {
                    this.conf = response.data;
                    this.$emit('loading', false);
                }, err => {

                });
            },
            approve() {
                // todo too specific
                this.$emit('loading', true);

                http.post('/certifications/approve/', {id: this.props.reviewId}).then(response => {
                    this.$closeCard(this.card);
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            reject() {
                // todo too specific
                this.$emit('loading', true);

                http.post('/certifications/reject/', {id: this.props.reviewId}).then(response => {
                    this.$closeCard(this.card);
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            getData(conf, field) {
                for (let i = 0; i < this.conf.config.data.length; i++) {
                    const datum = this.conf.config.data[i];
                    if (datum.field === field) {
                        return JSON.parse(datum.value);
                    }
                }
            },
            displayDates: function(start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('dddd, MMMM Do, h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, h:mm A') + ' - ' + e.format('MMM Do, h:mm A');
                }
            },
        },
        watch: {
            'props.reviewId': function() {
                this.loadReview();
            }
        },
        mounted: function() {
            this.loadReview();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .component-content {
        margin: 2rem 0;
    }
</style>
